import { TFunction } from "i18next";
import * as Yup from "yup";
import { TechMapCategoryNewProxy, TechnologicalMapServiceRelationProxy } from "@me-team/host/main/graphql/types";

export const calculateTechMapConnectServiceCount = (connectServices: TechnologicalMapServiceRelationProxy[]) => {
    if (!connectServices || connectServices?.length === 0) {
        return "—";
    }
    return connectServices?.length;
};

export const techMapFormValidationSchema = (t: TFunction) =>
    Yup.object().shape({
        name: Yup.string().trim().required(t("validation.required")),
        categoryId: Yup.number().required(t("validation.required")),
    });

export const getStartValueCategory = (productCategoryNew?: TechMapCategoryNewProxy): number => {
    return productCategoryNew?.parentCategory?.id ? productCategoryNew.parentCategory.id : productCategoryNew?.id;
};

export const getStartValueSubCategory = (productCategoryNew?: TechMapCategoryNewProxy): number | null => {
    return productCategoryNew?.parentCategory?.id ? productCategoryNew.id || null : null;
};

export const getCategoryName = (productCategoryNew?: TechMapCategoryNewProxy): string => {
    return productCategoryNew?.parentCategory?.name ? productCategoryNew.parentCategory.name : productCategoryNew?.name;
};

export const getSubCategoryName = (productCategoryNew?: TechMapCategoryNewProxy): string | null => {
    return productCategoryNew?.parentCategory?.name ? productCategoryNew.name || null : null;
};

export const truncateText = (text: string, maxLength: number) => {
    if (!text) return " — ";

    if (text.length > maxLength) {
        return text.slice(0, maxLength) + "...";
    }
    return text;
};

export const getProductCountByTechMap = (techMapProductsLength: number) => {
    if (techMapProductsLength && techMapProductsLength > 0) {
        return techMapProductsLength;
    }
    return "—";
};
